import { Component, forwardRef, OnDestroy } from '@angular/core';
import { ControlValueAccessor, FormBuilder, FormControl, FormGroup, NG_VALIDATORS, NG_VALUE_ACCESSOR, Validators } from '@angular/forms';

import { Subscription } from 'rxjs';
import { NameFormValues } from 'src/app/model';
import { SubmitButtonClickService } from 'src/app/services';

@Component({
  selector: 'app-name-form',
  templateUrl: './name-form.component.html',
  styleUrls: ['./name-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NameFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NameFormComponent),
      multi: true
    }
  ]
})
export class NameFormComponent implements ControlValueAccessor, OnDestroy {

  submitted: boolean = false;
  form: FormGroup;
  private _subscriptions: Subscription[] = [];
  private _valueChangesSubscription: Subscription;
  private _getSubmitButtonClickSubscription: Subscription;
  private _getSubmitButtonSuccessSubscription: Subscription;


  constructor(
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService
  ) {
    this.form = this._fb.group({
      firstName: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      middleName: [''],
      lastName: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });

    this._subscriptions.push(
      // any time the inner form changes update the parent of any change
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
    this._getSubmitButtonClickSubscription = this._submitButtonClick.getSubmitButtonClick().subscribe((res: any) => {
      this.submitted = true;
    });
    this._getSubmitButtonSuccessSubscription = this._submitButtonSuccess.getSubmitButtonSuccess().subscribe((res: any) => {
      this.submitted = false;
    })
  }

  get value(): NameFormValues {
    return this.form.value;
  }

  get nameFormValues() {
    return this.form.controls;
  }

  set value(value: NameFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();
    this._getSubmitButtonClickSubscription?.unsubscribe();
    this._getSubmitButtonSuccessSubscription?.unsubscribe();

  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: NameFormValues | null) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { name: { valid: false } };
  }

}
